import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Technologysec(props) {
  const [activeTab, setActiveTab] = useState(1);

  function displayTab(tabNumber) {
    setActiveTab(tabNumber);
  }

  return (
    <>
      <div className="tekgriping_section p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
              <div className="example" data-text="Our Forte">
                <h2>Our Services</h2>
              </div>
              <p>
                We help you scale your business with hardware-to-cloud and
                cloud-to-cloud infrastructure migration services. We are a group
                of highly skilled and experienced tech workers who deal in
                infrastructure migration services to Amazon Web Services (AWS).
                While dealing with leading cloud platforms and providing
                top-notch services, we provide your business with the best of
                all the cloud platforms in a way that is more technical for us
                and customized for you.
              </p>
            </Col>
            <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
              <div className="tekgrip_flex">
                <div className="tekgrip_title">
                  <h5>
                    2X
                    <span>Increase in ROI</span>
                  </h5>
                </div>
                <div className="tekgrip_title">
                  <h5>
                    60%
                    <span>Increase in Efficiency</span>
                  </h5>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
              <h3
                onClick={() => {
                  displayTab(1);
                }}
                className={`tabs ${activeTab === 1 ? "active" : ""}`}
              >
                <div className="tab_namee">Hardware to Cloud</div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(2);
                }}
                className={`tabs ${activeTab === 2 ? "active" : ""}`}
              >
                <div className="tab_namee">Cloud to Cloud</div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(3);
                }}
                className={`tabs ${activeTab === 3 ? "active" : ""}`}
              >
                <div className="tab_namee">
                  Infrastructure Migration Support
                </div>
              </h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
        <Container className="h-100">
          <Row className={activeTab === 1 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Hardware to Cloud</h2>
                <p>
                  Talking about the transition of your on-premises
                  infrastructure to the cloud, our hardware-to-cloud migration
                  services can efficiently manage it. Our team with experience
                  will take care of all aspects of the migration process, from
                  the assessment of our existing hardware setup to a customized
                  cloud solution design and implementation. You can breathe the
                  fresh air of digitalization through cloud infrastructure in
                  terms of flexibility, scalability, and cost savings.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <StaticImage
                  src="../../images/services/infrastructure/hardware.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 2 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Cloud to Cloud</h2>
                <p>
                  Cloud-to-cloud migration of your existing cloud infrastructure
                  can be smoothly performed with our migration services between
                  existing cloud providers or environments. Whether the goal is
                  to enhance efficiency, contain costs, or improve security our
                  transition process guarantees a seamless migration with no
                  hiccups during your business operations. Let us take care of
                  the complicated migration process when moving to the cloud;
                  freeing up your schedule to address business needs.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image">
                <StaticImage
                  src="../../images/services/infrastructure/cloud.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 3 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Infrastructure Migration Support</h2>
                <p>
                  Get comprehensive support during and after the infrastructure
                  migration with our Infrastructure Migration Support package.
                  We take charge of all the aspects from startup to wrap-up and
                  include a team of experts who are always available to help and
                  guide you. We will be your supporter regardless if it is your
                  migration to the cloud, upgrade of hardware, or data center
                  consolidation. Rest assured that your migration experience
                  will be easy and stress-free.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <StaticImage
                  src="../../images/services/infrastructure/infra_mig.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Technologysec;
